export let TimelineGridEventRowDataAttributes = /*#__PURE__*/function (TimelineGridEventRowDataAttributes) {
  /**
   * The ID of the resource for this event row.
   */
  TimelineGridEventRowDataAttributes["resourceId"] = "data-resource-id";
  return TimelineGridEventRowDataAttributes;
}({});